import type {AppThunk} from '../../../actions/types'
import type {BuildId, BuildTypeId, ProjectId, TestId} from '../../../types'
import {stringifyId} from '../../../types'
import {BS} from '../../../types/BS_types'
import type {WritableKeyValue} from '../../../utils/object'

export const showTestMetadataGraph =
  (
    anchor: EventTarget,
    testNameId: TestId,
    buildId: BuildId,
    escapedName: string,
    buildTypeId: BuildTypeId | null | undefined,
  ): AppThunk<any> =>
  () =>
    buildTypeId != null &&
    BS?.TestMetadata?.showGraph(anchor, testNameId, buildId, escapedName, buildTypeId)

export const assignTestInvestigations =
  (
    projectId: ProjectId,
    tests: ReadonlyArray<TestId>,
    flakyTests: ReadonlyArray<TestId>,
    buildIds: ReadonlyArray<BuildId>,
    fixMode = false,
    submitHandler?: () => unknown,
  ): AppThunk<any> =>
  () => {
    const testsData: WritableKeyValue<string, string> = {
      projectId: stringifyId(projectId),
    }
    const flakyTestIds: WritableKeyValue<string, boolean> = {}
    tests.forEach(item => {
      const key = stringifyId(item)
      testsData[key] = `${buildIds.join(',')},`
      flakyTestIds[key] = flakyTests.includes(item)
    })
    BS?.BulkInvestigateMuteTestDialog?.show(testsData, fixMode, flakyTestIds, true, submitHandler)
  }
